var preferencesData = {};

document.addEventListener("DOMContentLoaded", function() {
    // Initialize default age selection
    var defaultAgeCheckbox = document.querySelector('#ageCheckboxes input[type="checkbox"]:first-child');
    if (defaultAgeCheckbox) {
        defaultAgeCheckbox.checked = true;
        selectAge(defaultAgeCheckbox);
    }
});

function toggleCheckboxes(id, event) {
    // Stop event propagation to prevent multiple triggers
    if (event) event.stopPropagation();
    
    // Validate input
    if (!['age', 'preferences'].includes(id)) {
        console.error('Invalid dropdown ID:', id);
        return;
    }

    // Get dropdown elements
    var currentDropdown = document.getElementById(id + 'Checkboxes');
    var currentWrapper = document.querySelector('.' + id + '-dropdown .checkboxes-wrapper');
    var otherDropdownId = id === 'age' ? 'preferences' : 'age';
    var otherDropdown = document.getElementById(otherDropdownId + 'Checkboxes');
    var otherWrapper = document.querySelector('.' + otherDropdownId + '-dropdown .checkboxes-wrapper');

    // Null checks
    if (!currentDropdown || !currentWrapper) {
        console.error('Dropdown elements not found for:', id);
        return;
    }

    // Close other dropdown if open
    if (otherDropdown && otherDropdown.classList.contains('open')) {
        otherDropdown.classList.remove('open');
        if (otherWrapper) otherWrapper.classList.remove('open');
    }

    // Toggle current dropdown and wrapper
    currentDropdown.classList.toggle('open');
    currentWrapper.classList.toggle('open');

    // Update arrow icons
    updateDropdownArrows(id, currentDropdown.classList.contains('open'));
}

function updateDropdownArrows(id, isOpen) {
    var arrows = {
        age: {
            down: document.querySelector('.age-arrow'),
            up: document.querySelector('.age-down-arrow')
        },
        preferences: {
            down: document.querySelector('.sub-arrow'),
            up: document.querySelector('.sub-down-arrow')
        }
    };

    if (arrows[id]) {
        if (arrows[id].down) arrows[id].down.style.display = isOpen ? 'none' : 'block';
        if (arrows[id].up) arrows[id].up.style.display = isOpen ? 'block' : 'none';
    }
}

function selectAge(checkbox) {
    var collectionId = checkbox.getAttribute('data-collection-id');
    var selectedAgeText = document.getElementById('selectedAgeText');
    var checkboxes = document.querySelectorAll('#ageCheckboxes input[type="checkbox"]');
    
    // Uncheck other age options
    checkboxes.forEach(function(cb) {
        if (cb !== checkbox) cb.checked = false;
    });
    
    // Update selected text
    selectedAgeText.textContent = checkbox.checked ? checkbox.value : "";
    
    // Prepare subcollections
    var subcollections = Array.from(
        document.querySelectorAll('input[type="checkbox"][data-collection-id="' + collectionId + '"]')
    ).map(checkbox => checkbox.value);
    
    selectSubCollection(subcollections);
    closeCheckboxes('age');
}

function selectSubCollection(subcollections) {
    closeCheckboxes('preferences');
    var $preferencesText = $('#selectedPreferencesText');
    
    // Hide all subcollection options
    $('.subcollection-div').hide().find('input[type="checkbox"]').prop('checked', false);
    $preferencesText.text('');
    
    if (subcollections.length > 0) {
        var $defaultSub = $('.subcollection-div[data-id="' + subcollections[0] + '"]').first();
        if ($defaultSub.length) {
            $defaultSub.show();
            $preferencesText.text($defaultSub.find('input[type="checkbox"]').val());
        }
    }
}

function selectSubCollec(checkbox) {
    var selectedPreferencesText = document.getElementById('selectedPreferencesText');
    var checkboxes = document.querySelectorAll('#preferencesCheckboxes input[type="checkbox"]');
    
    // Uncheck other options
    checkboxes.forEach(function(cb) {
        if (cb !== checkbox) cb.checked = false;
    });
    
    // Update selected text
    selectedPreferencesText.textContent = checkbox.checked ? checkbox.value : "";
    closeCheckboxes('preferences');
}

function closeCheckboxes(id) {
    var dropdown = document.getElementById(id + 'Checkboxes');
    var wrapper = document.querySelector('.' + id + '-dropdown .checkboxes-wrapper');
    if (dropdown) {
        dropdown.classList.remove('open');
        if (wrapper) wrapper.classList.remove('open');
        updateDropdownArrows(id, false);
    }
}

function findGift() {
    var $ageChecked = $('#ageCheckboxes input[type="checkbox"]:checked');
    var $subChecked = $('.subcollection-div:visible input[type="checkbox"]:checked');
    
    // Validation
    if ($ageChecked.length === 0 || $subChecked.length === 0) {
        alert('Please select options in both dropdowns.');
        return false;
    }
    
    // Prepare URL
    var collectionHandle = $ageChecked.val().replace(/\s+/g, '+');
    var subHandles = $subChecked.map(function() {
        return $(this).val().replace(/\s+/g, '+');
    }).get().join('&filter.p.tag=');
    
    var url = [
        'https://edusparktoys.com/collections/all-products-collection?',
        '&filter.p.tag=' + collectionHandle,
        '&filter.p.tag=' + subHandles
    ].join('').replace(/\+&\+/g, '+%26+');
    
    // Reset and open URL
    $('.subcollection-div input[type="checkbox"]').prop('checked', false);
    window.open(url, '_blank');
}